import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ManageDevelopers = lazy(() =>
  import("@scenes/PermissionSettings/components/ManageDevelopers").then((module) => ({
    default: module.ManageDevelopers,
  }))
);

export const userManagementNRO: NavigationRoutingObject = {
  Component: ManageDevelopers,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("user-management", "User Management"),
  pageNameForTracking: () => "User Management",
  getDeveloperNavigationAllowed: ({ isFreeTrial, hasPermissionForAnyScope }) => {
    const canEditDashboardUsers = isFreeTrial
      ? hasPermissionForAnyScope("viewFreeTrialDevelopers")
      : hasPermissionForAnyScope("editDashboardUsers");

    return canEditDashboardUsers || hasPermissionForAnyScope("manageCompanySettings");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("company-users-manage-users", "Manage Users")],
      description: t("previously-manage-users", 'Previously "Manage Users"'),
    },
    {
      keywords: [t("company-users-nro-additional-keyword-invite", "Invite Users")],
      description: t("company-users-nro-additional-description-invite", "Invite Users to Braze"),
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/user_management/:appGroupId",
};
